import styled from 'styled-components';
import { ItemBackground } from 'shared/styles/commonStyles';
import { useMemo } from 'react';
import { useLocations } from 'shared/hooks';

const DisplaySwitchSuggestion = ({
  matchedSuggestion,
  isSelected,
  handleSelect,
  column,
  handleClose,
}) => {
  const handleOnClick = () => {
    handleSelect(column, matchedSuggestion, true);
    handleClose();
  };
  const locations = useLocations();















  const title = useMemo(() => {
    return matchedSuggestion
      ?.split(' - ')
      .map((el, index) => {
        if (index === 0) {
          if (locations.all[el]?.locationName) {
            return locations.all[el]?.locationName?.toUpperCase();
          }
          const specificLocationName = matchedSuggestion.split(' - ')[1];

          return locations.all[el][
            specificLocationName
          ]?.locationName?.toUpperCase();
        } else if (matchedSuggestion.split(' - ').length > 2) {

          const names = matchedSuggestion.split(' - ');
          if (index === 1) {
            return locations.all[names[0]][names[1]].devices[
              names[2]
            ]?.specificLocationName?.toUpperCase();
          }
          return locations.all[names[0]][names[1]].devices[
            names[2]
          ]?.machineName?.toUpperCase();
        } else {

          return locations.all[matchedSuggestion.split(' - ')[0]]?.devices[el]
            ?.machineName;
        }
      })
      .join(' - ');
  }, [matchedSuggestion, locations.all]);



































































  return (
    <Wrapper isSelected={isSelected} onClick={handleOnClick}>
      <Prediction>{title}</Prediction>
    </Wrapper>
  );
};
export default DisplaySwitchSuggestion;

const Wrapper = styled.li`
  width: 100%;

  ${ItemBackground};

  background-color: ${(p) => p.isSelected && `hsla(50deg, 100%, 80%,0.25)`};
  &:hover {
    background-color: hsla(50deg, 100%, 80%, 0.25);
  }

  margin-bottom: 2px;
  :last-child {
    margin-bottom: 0px;
  }
  padding-left: 10px;
  cursor: pointer;
`;

const Prediction = styled.div`
  width: 100%;
  height: 20px;

  font-size: 10px;
  letter-spacing: 1px;

  display: flex;
  align-items: center;
`;
